import { render, staticRenderFns } from "./renameDialog.vue?vue&type=template&id=b1a2a8e0&"
import script from "./renameDialog.vue?vue&type=script&lang=js&"
export * from "./renameDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports